var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{staticClass:"w-100",attrs:{"id":_vm.id,"controls":"","autoplay":_vm.autoplay}},[_c('source',{attrs:{"src":_vm.src,"type":"audio/mp3"}}),_vm._v(" Your browser does not support the audio element. ")])}
var staticRenderFns = []

export { render, staticRenderFns }